import { createSlice } from "@reduxjs/toolkit"
//import axios from 'axios';


const dt = new Date()
const time = dt.getHours() + ":" + dt.getMinutes() + ":" + dt.getSeconds();
const day = dt.getUTCDate();
const month = String(dt.getMonth() + 1).padStart(2, '0');
const year = dt.getFullYear();
const date = year + "-" + month + "-" + day;

let data = []

if (localStorage.getItem("workers") !== null && localStorage.getItem("workers") !== undefined && localStorage.getItem("workers") !== "") {

    data = [JSON.parse(localStorage.getItem("workers"))]

}


const Insider = createSlice({

    name: "todos",
    initialState: data,
    reducers: {

        getdatateacher: (state, action) => {

            return action.payload.data || [];

        },

        logout_: (state, action) => {


            localStorage.clear()
            state = []


        },

        updateteacherdata: (state, action) => {


            return action.payload.data || [];

        },


    }
})

export const { logout_, updateteacherdata, login, getdatateacher } = Insider.actions;
export default Insider.reducer;